export const WorkflowOptionFragment = gql`
  fragment WorkflowOptionFragment on Workflow {
    id
    completedAt
    createdAt
    status
    workflowTemplate {
      id
      name
    }
  }
`
export const WorkflowFragment = gql`
  fragment WorkflowFragment on Workflow {
    id
    recordTaskGroups {
      ...WorkflowRecordTaskGroupFragment
    }
    recordTaskInspectionGroups {
      id
    }
    workflowTemplate {
      id
    }
    generatedDocuments {
      id
    }
  }
`

export const RecordTaskGroupBaseFragment = gql`
  fragment RecordTaskGroupBaseFragment on RecordTaskGroup {
    id
    type
    recordTasks {
      ...RecordTaskBaseFragment
    }
  }
`

export const WorkflowRecordTaskGroupFragment = gql`
  fragment WorkflowRecordTaskGroupFragment on RecordTaskGroup {
    ...RecordTaskGroupBaseFragment
    automaticTaskExplanation
    completedAt
    hasAutomaticTasks
    isLocked
    name
    ordinal
    record {
      id
      applicantUser {
        ...UserDataFragment
      }
      status {
        ...RecordTypeStatusFragment
      }
    }
    recordTaskTemplateGroup {
      attachGeneratedDocumentsByDefault
      changeToStatus {
        ...RecordTypeStatusFragment
      }
      defaultRenewalWorkflowTemplateId
      defaultEmailTemplate {
        id
      }
      defaultEmailApplicant
      defaultEmailOwner
      defaultRecipientUsers {
        ...UserDataFragment
      }
      defaultSearchForNearbyPropertiesDistanceUnit
      defaultSearchForNearbyPropertiesDistanceValue
      defaultSearchForNearbyPropertiesEntityLayer {
        id
      }
      id
      identifier
      notificationScheduledEventTemplates {
        id
      }
      requestedRecordConfigs {
        ...RecordTaskTemplateGroupRequestedRecordFragment
      }
      shouldRenewAsNewRecord
      workflowScheduledEventTemplates {
        id
        beginWorkflowTemplateId
        dateTemplate {
          ...DateTemplateFragment
        }
      }
    }
    recordTasks {
      ...WorkflowRecordTaskFragment
    }
    startedAt
    status
  }
`

export const RecordTaskBaseFragment = gql`
  fragment RecordTaskBaseFragment on RecordTask {
    id
    status
  }
`

export const WorkflowRecordTaskFragment = gql`
  fragment WorkflowRecordTaskFragment on RecordTask {
    ...RecordTaskBaseFragment
    uuid
    name
    dueDate
    updatedAt
    startedAt
    completedAt
    completedAutomatically
    type
    isWaitingOnApplicant
    applicationReviewComment
    applicationReviewResult
    applicationReviewedAt
    applicationReviewCanceledAt
    applicationReviewDeclinedAt
    planReviewRevisionRequestComment
    isCustomTaskAndInProgress
    attachedAutoCheckFeedbackItems {
      ...AutoCheckFeedbackItemFragment
    }
    attachedApplicationReviewComments {
      ...ApplicationReviewCommentFragment
    }
    plansSetReview {
      id
      totalComments
      recordPlansSetId
      result {
        id
        name
        isPassing
      }
    }
    checklistItems {
      ...RecordTaskChecklistItemFragment
    }
    completedByUser {
      ...UserDataFragment
    }
    createdByUser {
      ...UserDataFragment
    }
    createdRecord {
      id
      uuid
    }
    fieldGroup {
      ...FieldGroupFragment
    }
    completedByUser {
      ...UserDataFragment
    }
    ownerUser {
      ...UserDataFragment
    }
    recordTaskPayment {
      isPayable
      totalWhenInvoiceRequestedCents
      status
    }
    recordTaskTemplate {
      name
      addFilesToPlanReview
      taskTemplate {
        id
        identifier
        fieldGroup {
          ...FieldGroupFragment
        }
      }
    }
    requestedRecordTemplate {
      ...RecordTemplateOptionFragment
    }
    revisionOfPlansSet {
      id
    }
    recordTaskGroup {
      id
      record {
        id
        uuid
      }
    }
    workOrderActivityCompletionDate
    workOrderActivityStartDate
    workOrderActivityComments
    workOrderType {
      id
      name
    }
    workOrderActivityCustomFieldsFieldGroup {
      ...FieldGroupFragment
    }
    workOrderActivityBeforePhotosField {
      ...FieldFragment
    }
    workOrderActivityAfterPhotosField {
      ...FieldFragment
    }
  }
`
